export default __webpack_public_path__ + "static/media/None_Option.69d1f786.svg";